/** Shared column widths so Moderation + Scheduled headers line up */
export const STATS_COL = {
  when: 200,
  preview: 180,
  by: 130,
  involved: 150,
  actions: 120,
} as const;

export const STATS_COL_MOBILE = {
  when: 132,
  preview: 120,
  by: 72,
  involved: 100,
  actions: 96,
} as const;

export const STATS_TABLE_SCROLL_X = {
  desktop: 800,
  mobile: 560,
} as const;

export function getStatsCol(isMobile: boolean) {
  return isMobile ? STATS_COL_MOBILE : STATS_COL;
}

export function getStatsTableScrollX(isMobile: boolean) {
  return isMobile ? STATS_TABLE_SCROLL_X.mobile : STATS_TABLE_SCROLL_X.desktop;
}

/** Scheduled posts: no Target column — wider Submitted by + Actions */
export const SCHEDULED_STATS_COL = {
  when: 200,
  preview: 180,
  by: 160,
  actions: 140,
} as const;

export const SCHEDULED_STATS_COL_MOBILE = {
  when: 132,
  preview: 120,
  by: 88,
  actions: 112,
} as const;

export const SCHEDULED_TABLE_SCROLL_X = {
  desktop: 680,
  mobile: 452,
} as const;

export function getScheduledStatsCol(isMobile: boolean) {
  return isMobile ? SCHEDULED_STATS_COL_MOBILE : SCHEDULED_STATS_COL;
}

export function getScheduledTableScrollX(isMobile: boolean) {
  return isMobile ? SCHEDULED_TABLE_SCROLL_X.mobile : SCHEDULED_TABLE_SCROLL_X.desktop;
}
